import EventAvailableOutlined from '@mui/icons-material/EventAvailableOutlined';
import NotificationsActiveOutlined from '@mui/icons-material/NotificationsActiveOutlined';
import WavingHandOutlined from '@mui/icons-material/WavingHandOutlined';
import StarHalfOutlined from '@mui/icons-material/StarHalfOutlined';
import RateReviewOutlined from '@mui/icons-material/RateReviewOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import EventRepeatOutlined from '@mui/icons-material/EventRepeatOutlined';
import CakeOutlined from '@mui/icons-material/CakeOutlined';
import TodayOutlined from '@mui/icons-material/TodayOutlined';

export const AUTOMATION_GROUPS = [
  {
    id: 'before_appointment',
    title: 'Antes da consulta',
    items: [
      {
        type: 'appointment_confirmation',
        title: 'Confirmação de consulta',
        icon: EventAvailableOutlined,
        description: 'Pede a confirmação da presença, com botões para confirmar ou reagendar/cancelar. Com o seu número de WhatsApp conectado, sai sozinha; sem ele, fica pronta no Início para enviar com um clique.',
        schedule: 'Todo dia às 08:00, 12:10 e 17:30',
        audience: 'Paciente',
        conditions: [
          'Consulta marcada para amanhã e ainda com status "agendado" (não confirmada)',
          'Às sextas-feiras, inclui também as consultas de segunda',
          'Se a consulta continuar sem confirmação, o paciente recebe os três envios do dia, o último pedindo confirmação em até 30 minutos'
        ]
      },
      {
        type: 'appointment_reminder',
        title: 'Lembrete de consulta',
        icon: NotificationsActiveOutlined,
        description: 'Lembra o paciente de uma consulta que acontece na semana seguinte.',
        schedule: 'Todo dia às 15:05',
        audience: 'Paciente',
        conditions: [
          'Consulta daqui a exatamente 7 dias, com status "agendado"',
          'A consulta precisa ter sido marcada há pelo menos 7 dias'
        ]
      }
    ]
  },
  {
    id: 'after_appointment',
    title: 'Depois da consulta',
    items: [
      {
        type: 'first_appointment_followup',
        title: 'Boas-vindas após a primeira consulta',
        icon: WavingHandOutlined,
        description: 'Mensagem de acompanhamento para quem acabou de fazer a primeira consulta na clínica.',
        schedule: 'Todo dia às 09:10',
        audience: 'Paciente',
        conditions: [
          'Consulta concluída ontem',
          'É a primeira consulta do paciente na clínica'
        ]
      },
      {
        type: 'nps_survey',
        title: 'Pesquisa de satisfação (NPS)',
        icon: StarHalfOutlined,
        description: 'Envia o link da pesquisa de satisfação após a consulta.',
        schedule: 'Todo dia às 12:30',
        audience: 'Paciente',
        conditions: [
          'Consulta concluída há 2 dias',
          'Cada paciente recebe a pesquisa uma única vez, mesmo que volte a se consultar'
        ]
      },
      {
        type: 'google_review',
        title: 'Convite para avaliar no Google',
        icon: RateReviewOutlined,
        description: 'Convida pacientes satisfeitos a deixar uma avaliação pública no Google.',
        schedule: 'Logo após a resposta da pesquisa',
        audience: 'Paciente',
        conditions: [
          'Paciente deu nota 9 ou 10 na pesquisa de satisfação',
          'Exige o link de avaliação do Google configurado na clínica'
        ]
      },
      {
        type: 'canceled_appointment_followup',
        title: 'Retomada após cancelamento',
        icon: EventRepeatOutlined,
        description: 'Convida o paciente que cancelou a remarcar a consulta.',
        schedule: 'Todo dia às 12:05',
        audience: 'Paciente',
        conditions: [
          'Consulta cancelada pelo paciente cuja data era há 5 dias',
          'O paciente não tem nenhuma consulta futura marcada'
        ]
      },
      {
        type: 'fiscal_invoice_send',
        title: 'Envio da nota fiscal',
        icon: ReceiptLongOutlined,
        description: 'Envia a NFS-e ao paciente assim que a prefeitura autoriza, com o link da nota em um botão.',
        schedule: 'Assim que a nota fica pronta',
        audience: 'Paciente',
        conditions: [
          'Nota fiscal autorizada e com PDF disponível',
          'Paciente com telefone cadastrado',
          'Exige o número próprio de WhatsApp da clínica'
        ]
      }
    ]
  },
  {
    id: 'relationship',
    title: 'Relacionamento',
    items: [
      {
        type: 'birthday_message',
        title: 'Mensagem de aniversário',
        icon: CakeOutlined,
        description: 'Parabeniza o paciente no dia do aniversário.',
        schedule: 'Todo dia às 10:02',
        audience: 'Paciente',
        conditions: [
          'Pacientes que fazem aniversário hoje',
          'Precisa ter telefone cadastrado'
        ]
      }
    ]
  },
  {
    id: 'team',
    title: 'Para a sua equipe',
    items: [
      {
        type: 'daily_schedule_summary',
        title: 'Resumo da agenda do dia',
        icon: TodayOutlined,
        description: 'Envia a agenda do dia por e-mail para a empresa e para cada profissional.',
        schedule: 'Todo dia às 06:00',
        audience: 'Clínica e profissionais',
        conditions: [
          'A agenda completa vai para o e-mail cadastrado da empresa',
          'Cada profissional com e-mail cadastrado recebe só a própria agenda',
          'Inclui consultas do dia e bloqueios; ignora canceladas, remarcadas e faltas'
        ]
      }
    ]
  }
];

export default AUTOMATION_GROUPS;
